import { noAuthGuard } from '@/shareds/router-guards';
import { RouteConfig } from 'vue-router';

const rotasDeAvaliacaoNpsDoCliente: RouteConfig[] = [
	{
		path: '/avaliacao/:identificador',
		name: 'Avaliação',
		component: () => 
			import('@/views/application/avaliacaoNps/TelaDeAvaliacaoNpsDoCliente.vue'),
		beforeEnter: noAuthGuard,
	},
]

export default rotasDeAvaliacaoNpsDoCliente